export default __webpack_public_path__ + "static/media/qrupload.f3c0b8bd.svg";